/**
 * gtm.js — Google Tag Manager, erst nach erteiltem Cookie-Consent
 * ---------------------------------------------------------------------------
 * Der Container wird NICHT beim Seitenaufbau geladen. Erst wenn Shopifys
 * Consent-API meldet, dass Analytics oder Marketing erlaubt sind, kommt
 * gtm.js ins Dokument. Sagt der Besucher nein, wird nie eine Anfrage an
 * googletagmanager.com gestellt.
 *
 * Datenquelle ist ausschliesslich Shopifys eigenes Consent-Banner
 * (Admin -> Kundenberechtigungen / Cookie-Banner). Das Theme bringt kein
 * zweites Banner mit; der "Cookie-Einstellungen"-Button im Footer oeffnet
 * ueber theme.js denselben Shopify-Dialog.
 *
 * Zusaetzlich werden Google-Consent-Mode-v2-Signale in den dataLayer
 * geschrieben: default = alles denied, danach ein update mit dem echten
 * Zustand. So bleiben auch Tags im Container, die frueher als dieses Skript
 * feuern koennten, auf der sicheren Seite.
 *
 * Bewusst KEIN <noscript>-iframe: das laedt bedingungslos und liesse sich
 * nicht an den Consent binden.
 */

(() => {
  "use strict";

  var tag = document.querySelector("script[data-gtm-id]");
  var containerId = tag ? (tag.getAttribute("data-gtm-id") || "").trim() : "";
  if (!containerId) return;

  window.dataLayer = window.dataLayer || [];
  function gtag() {
    window.dataLayer.push(arguments);
  }

  // Ausgangslage: alles verweigert. Wird unten mit dem echten Zustand
  // ueberschrieben, sobald Shopify ihn kennt.
  gtag("consent", "default", {
    ad_storage: "denied",
    ad_user_data: "denied",
    ad_personalization: "denied",
    analytics_storage: "denied",
    functionality_storage: "denied",
    personalization_storage: "denied",
    security_storage: "granted"
  });

  var containerLoaded = false;

  function loadContainer() {
    if (containerLoaded) return;
    containerLoaded = true;

    window.dataLayer.push({ "gtm.start": new Date().getTime(), event: "gtm.js" });

    var script = document.createElement("script");
    script.async = true;
    script.src = "https://www.googletagmanager.com/gtm.js?id=" + encodeURIComponent(containerId);
    (document.head || document.documentElement).appendChild(script);
  }

  /**
   * Uebersetzt den Shopify-Consent in Consent-Mode-Signale und laedt den
   * Container, sobald mindestens eine der beiden relevanten Kategorien
   * erlaubt ist. Das update geht bewusst VOR dem Laden raus.
   */
  function applyConsent(consent) {
    gtag("consent", "update", {
      analytics_storage: consent.analytics ? "granted" : "denied",
      ad_storage: consent.marketing ? "granted" : "denied",
      ad_user_data: consent.marketing ? "granted" : "denied",
      ad_personalization: consent.marketing ? "granted" : "denied",
      functionality_storage: consent.preferences ? "granted" : "denied",
      personalization_storage: consent.preferences ? "granted" : "denied",
      security_storage: "granted"
    });

    if (consent.analytics || consent.marketing) loadContainer();
  }

  /**
   * Aktueller Zustand aus der Consent-API. Gibt in Regionen ohne
   * Banner-Pflicht true zurueck — das ist so gewollt und Shopifys Regel,
   * nicht unsere.
   */
  function currentConsent() {
    var api = window.Shopify && window.Shopify.customerPrivacy;
    if (!api || typeof api.analyticsProcessingAllowed !== "function") return null;
    return {
      analytics: api.analyticsProcessingAllowed(),
      marketing: typeof api.marketingAllowed === "function" ? api.marketingAllowed() : false,
      preferences: typeof api.preferencesProcessingAllowed === "function" ? api.preferencesProcessingAllowed() : false
    };
  }

  // Spaetere Entscheidung im Banner (annehmen, ablehnen, Einstellungen
  // speichern) — Shopify feuert das Event bei jeder Aenderung.
  document.addEventListener("visitorConsentCollected", function (event) {
    var detail = event.detail || {};
    applyConsent({
      analytics: !!detail.analyticsAllowed,
      marketing: !!detail.marketingAllowed,
      preferences: !!detail.preferencesAllowed
    });
  });

  // Bereits erteilter Consent aus einem frueheren Besuch: die API muss dafuer
  // geladen sein. Sie kommt ueber content_for_header, ist bei einem deferten
  // Skript also normalerweise schon da — der Fallback deckt den Rest ab.
  var attempts = 0;
  function withPrivacyApi() {
    var consent = currentConsent();
    if (consent) {
      applyConsent(consent);
      return;
    }
    if (window.Shopify && typeof window.Shopify.loadFeatures === "function") {
      window.Shopify.loadFeatures([{ name: "consent-tracking-api", version: "0.1" }], function (error) {
        if (error) return;
        var loadedConsent = currentConsent();
        if (loadedConsent) applyConsent(loadedConsent);
      });
      return;
    }
    // Shopify-Objekt noch nicht da (sehr frueher Aufruf): kurz nachfassen.
    if (attempts++ < 20) window.setTimeout(withPrivacyApi, 250);
  }

  withPrivacyApi();
})();
